<template>
    <div>
        <v-layout wrap justify-center align-center>
            <v-flex md7 sm7 xs12>
                <dialogos-app :dialogos="dialogos" tucan="2" @update:currentText="currentText = $event" :adelanteVisible="advisible"></dialogos-app>
            </v-flex>
        </v-layout>

        <!-- Primer contenido-->
        <v-layout wrap row justify-center align-center text-xs-center mt-2 class="cont_page animated fadeInDown dura-1" v-if="pag == 0">
          <v-flex xs11 sm7 md7  class="textos-personales">
              <v-text-field label="Nome:" :rules="rules" placeholder="Escreva aqui." v-model="textoPersonal[0]" hide-details="auto"></v-text-field>
              <v-text-field label="Sobrenome:" :rules="rules" placeholder="Escreva aqui." v-model="textoPersonal[1]" hide-details="auto"></v-text-field>
              <v-text-field label="Apelido:" :rules="rules" placeholder="Escreva aqui." v-model="textoPersonal[2]" hide-details="auto"></v-text-field>
              <v-text-field label="Nacionalidade:" :rules="rules" placeholder="Escreva aqui." v-model="textoPersonal[3]" hide-details="auto"></v-text-field>
              <v-text-field label="Lugar de nascimento:" :rules="rules" placeholder="Escreva aqui." v-model="textoPersonal[4]" hide-details="auto"></v-text-field>
          </v-flex>
          <v-flex xs12 sm7 md7 mt-4>
            <button class="btn-verificar hvr-scale" @click="guardar()">
              <span>Guardar</span>
            </button>
          </v-flex>
        </v-layout>
        <!-- Segunto contenido-->
        <v-layout wrap row justify-center align-center text-xs-center mt-3 class="cont_page animated fadeInDown dura-1" v-if="pag == 1">
          <v-flex xs12 sm7 md7  class="textos">
            <p>Bom dia, eu sou <br>
              <input :class="retroalimClass[0]" class="texto-input" type="text" value="" placeholder="Escreva aqui" v-model="texto[0]">
            e meu <br> sobrenome é 
            <input :class="retroalimClass[1]" class="texto-input" type="text" value="" placeholder="Escreva aqui" v-model="texto[1]">.<br> 
            Meu apelido é <br>
            <input :class="retroalimClass[2]" class="texto-input" type="text" value="" placeholder="Escreva aqui" v-model="texto[2]">.<br>
            Sou 
            <input :class="retroalimClass[3]" class="texto-input" type="text" value="" placeholder="Escreva aqui" v-model="texto[3]">.<br> 
            Nasci em
            <input :class="retroalimClass[4]" class="texto-input" type="text" value="" placeholder="Escreva aqui" v-model="texto[4]">. 
            </p>
          </v-flex>
          <v-flex xs12 sm7 md7>
            <button class="btn-verificar hvr-scale" @click="comprobar()">
              <span>Verificar</span>
            </button>
          </v-flex>
        </v-layout>

        <!-- Tercer contenido-->
        <v-layout wrap row justify-center align-center text-md-center mt-5 class="cont_page animated fadeInDown dura-1" v-if="pag == 2">
          <v-flex xs12 sm7 md7>
            <v-layout class="cont-item" row mt-2 justify-center align-center text-xs-center v-for="i in 5" :key="'item_texto'+i">
              <v-flex xs9 md7 mr-1 text-xs-center>
                <div class="item_texto btn-blue-dark"><span>{{textoTercer[i-1]}}</span></div>
              </v-flex>
              <v-flex xs2 md1 text-md-center class="cont_switch">
                <v-switch class="item_switch" 
                v-model="showMessages[i-1]"
                color="primary"
                hide-details
              ></v-switch>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- modal para segundo contenido -->
        <modal-resultado-app v-model="modalresultado" :nameResult="modalResult" @bienAvanzar="bienAction()">
        </modal-resultado-app>
    </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
export default {
  mixins: [nextConditions],
  data() {
    return {
      dialogos: [
        'Oi, amigo! Eu vou me apresentar e depois você se apresenta. Combinado?',
        'Eu me chamo Eduardo, e meu sobrenome é Machado. Meu apelido é Dudu. Sou brasileiro, de São Paulo.',
        'Escreva novamente os seus dados para completar a frase.',
        'Você é...?'
      ],
      currentText:0,
      texto:Array(5).fill(''),
      textoPersonal:Array(5).fill(''),
      todosCorrectos:['Eduardo','Machado','Dudu','Brasileiro','Brasil'],
      resultado:Array(5).fill(false),
      modalresultado:false,
      modalResult:'bien',
      textoTercer:['Solteiro (a)','Casado (a)','Viúvo (a)','Separado (a)','Divorciado (a)'],
      showMessages:Array(5).fill(''),
      pag:0,
      advisible:true,
      rules: [
        value => !!value || 'Required.',
        // value => (value && value.length >= 3) || 'Min 3 characters',
      ],
      retroalimText: '',
      retroalimClass: Array(5).fill(''),
    }
  },
  methods: {
    comprobar(){
      var todosCorrectosMay = String.prototype.toUpperCase.apply(this.textoPersonal).split(",");
      var textoMay = String.prototype.toUpperCase.apply(this.texto).split(",");
      for (var i = 0; i < 5; i++) {
        if(textoMay[i] == todosCorrectosMay[i]){
          this.$set(this.resultado,i,true)
          this.$set(this.retroalimClass,i,'bien')
        }else{
          this.$set(this.resultado,i,false)
          this.$set(this.retroalimClass,i,'mal')
        }
        var todosVistos = this.resultado.every(el => {return el})
        if(todosVistos){
           this.modalresultado = true
          this.modalResult = 'bien'
          
        }else{
          this.modalresultado = true
          this.modalResult = 'mal'
        }
      }
    },
    bienAction(){
         this.advisible = true
    },
    guardar(){
      for (var i = 0; i < 5; i++) {
        if(this.textoPersonal[i] == ''){
          return false
        }else{
          this.advisible = true
        }
      }
    }  
  },
  watch: {
    texto(value){
      console.log(value)
    },
    textoPersonal(value){
      console.log('persona '+ value)
    },
    showMessages(val){
       this.$store.commit('nextShow', true);
    },
    currentText(val){
      if(val == 0){
        this.pag = 0
        this.advisible = true
      }else if(val == 1){
        this.pag = 0
        this.advisible = false
      }else if(val == 2){
        this.pag = 1
        this.advisible = false
      }else if(val == 3){
        this.pag = 2
      }
    }

  },
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import '../../sass/globals';
.texto-input{
  text-align: center;
  border-bottom: solid gray 1px;
  font-family:Poppins-Regular;
  font-size: 14px;
  width: 90px;
}
.textos{
    font-family:Poppins-Regular;
  font-size: 16px;
}
.textos-personales{
  p{
  font-family:Poppins-Regular;
  font-size: 16px;
  text-align: center;
  margin: 0;
  padding: 0;
  font-weight: bolder;
  }
  input{
   width: 90%;

  }
}
.cont-dialogo{
  background: #81C7FD;
  padding: 20px;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  p{
    margin: 0;
    padding: 0;
    font-family:Poppins-Regular;
    font-size: 13px;
  }
}
.imagen-personaje-hombre{
  background: url('../../assets/unidad1/slide-3-1.jpg')no-repeat 70% 40%;
  width: 70px;
  height: 70px;
  background-size: 110px;
  border-radius: 50%;
  margin: 0 auto;
  margin-bottom: -10px;
  z-index: 1;
  position: relative;
}

.cont-item{

  .item_texto{
    margin: 0 auto;
    
  }
  .cont_switch{
    justify-items: center;
    display: flex;
    align-self: center;
    align-content: center;
    text-align: center;
  }
  .item_switch{
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-self: center;
  }

}

    .bien {
        background-color: #BEF299
    }

    .mal {
        background-color: #FFA1A1
    }
</style>
